import { formatDistanceToNow, format, parseISO, isValid } from 'date-fns';
import { Api } from '../api';
import { iriToId } from '../util';

export function formatTimeAgo(dateString: string): string {
  if (!dateString) return '';

  try {
    const date = parseISO(dateString);
    if (!isValid(date)) return '';

    const now = new Date();
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      return formatDistanceToNow(date, { addSuffix: false });
    } else {
      return format(date, 'd MMM');
    }
  } catch {
    return '';
  }
}

export function findChatByUserId(
  chats:
    | Array<Api.ChatConversation.V_Active | Api.ChatConversation.V_Archived>
    | undefined,
  userId: string | undefined,
): Api.ChatConversation.V_Active | Api.ChatConversation.V_Archived | undefined {
  if (!chats || !userId) return undefined;
  return chats.find((c) => {
    if (c.user && iriToId(c.user['@id']) === userId) {
      return true;
    }
    return false;
  });
}

export function findBroadcastChat(
  chats: Array<Api.ChatConversation.V_Broadcast> | undefined,
  entityId: string | undefined,
  isTeam: boolean,
): Api.ChatConversation.V_Broadcast | undefined {
  if (!chats || !entityId) return undefined;
  return chats.find((c) => {
    if (isTeam && c.team && iriToId(c.team['@id']) === entityId) {
      return true;
    }
    if (!isTeam && c.user && iriToId(c.user['@id']) === entityId) {
      return true;
    }
    return false;
  });
}
